import { render, staticRenderFns } from "./ZabbixEventList.vue?vue&type=template&id=556521e4&"
import script from "./ZabbixEventList.vue?vue&type=script&lang=js&"
export * from "./ZabbixEventList.vue?vue&type=script&lang=js&"
import style0 from "./ZabbixEventList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports